import React from "react";
import { connect } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";

class Page404_LoggedIn extends React.Component {
  render() {
    return (
      <div
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div style={{ flex: 1 }}>
          <div className="container-fluid">
            <div className="body">
              <div className="row">
                <div className="col-lg-6 offset-lg-2 mt-4 col-md-8 offset-md-2">
                  <div className="card ">
                    <div className="header">
                      <h3>
                        <span className="clearfix title">
                          <span className="number left mr-1">404</span>
                          <span className="text">
                            Oops! <br />
                            Page Not Found
                          </span>
                        </span>
                      </h3>
                    </div>
                    <div className="body">
                      <p>
                        The page you were looking for could not be found, please{" "}
                        <a>contact us</a> to report this issue.
                      </p>
                      <div className="margin-top-30">
                        <a
                          className="btn btn-default"
                          onClick={() => {
                            this.props.history.push("/Dashboard");
                          }}
                        >
                          <i className="fa fa-arrow-left"></i>&nbsp;
                          <span>Go Back</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Page404_LoggedIn.propTypes = {};

const mapStateToProps = ({ loginReducer }) => ({});

export default connect(mapStateToProps, {})(Page404_LoggedIn);
